import { Alert, Snackbar, SnackbarCloseReason } from "@mui/material";
import { useShallow } from "zustand/react/shallow";
import { useNotificationStore } from "../../State/Stores/NotificationStore";

export function RenderSnackbar() {
  const { open, autoClose, timeout, type, message, clearNotification } = useNotificationStore(
    useShallow((state) => ({
      open: state.open,
      autoClose: state.autoClose,
      timeout: state.timeout,
      type: state.type,
      message: state.message,
      clearNotification: state.clearNotification,
    })),
  );

  const handleClose = (_: unknown, reason?: SnackbarCloseReason) =>
    reason !== "clickaway" && clearNotification();

  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      autoHideDuration={autoClose ? timeout : null}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      data-test="snackbar"
    >
      <Alert variant="filled" onClose={handleClose} severity={type} sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );
}
